module.exports = __webpack_public_path__ + "img/menu_privacy.98ce728e.svg";